import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ReactNode} from "react";

interface ModalStateConfigBtns {
    onClick: () => void;
    title: string;
    active: boolean;
    isLoading?: boolean;
}

interface ModalStateConfig {
    btns?: ModalStateConfigBtns[] | null;
    title: string;
}

interface ModalState {
    isOpen: boolean;
    isFullScreen?: boolean,
    config: ModalStateConfig | null;
    content: string | ReactNode | null;
}

const initialState: ModalState = {
    isOpen: false,
    isFullScreen: false,
    content: null,
    config: null
};

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action: PayloadAction<ModalState>) => {
            state.isOpen = true;
            state.isFullScreen = action.payload.isFullScreen;
            state.content = action.payload.content;
            state.config = action.payload.config;
        },
        closeModal: state => {
            state.isOpen = false;
            state.isFullScreen = false;
            state.content = null;
            state.config = null;
        },
    },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
